import { render, staticRenderFns } from "./medicalAesthetics.vue?vue&type=template&id=20bcb4f5&"
import script from "./medicalAesthetics.vue?vue&type=script&lang=js&"
export * from "./medicalAesthetics.vue?vue&type=script&lang=js&"
import style0 from "./medicalAesthetics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports